export default __webpack_public_path__ + "static/media/how-work-img-01.394fb81f.svg";